import { render, staticRenderFns } from "./AddSubstanceForm.vue?vue&type=template&id=43c9fe5a&"
import script from "./AddSubstanceForm.vue?vue&type=script&lang=js&"
export * from "./AddSubstanceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports